<template>
    <div class="prop-box">
        <el-form label-width="auto">
            <!-- {{ myObj }} -->

            <el-form-item label="模板">
                <el-select v-model="myObj.params.template" placeholder="请选择">
                    <el-option v-for="item, index in myTemplateOptioins" :key="index" :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="大栏目">
                <el-autocomplete v-model="queryCategory" :fetch-suggestions="querySearchCategory" placeholder="搜索/选择大栏目"
                    @select="handleSelectCategory" clearable></el-autocomplete>
            </el-form-item>

            <el-form-item label="标签">
                <el-autocomplete class="" v-model="queryTag" :fetch-suggestions="querySearchTag" placeholder="搜索/选择标签"
                    @select="handleSelectTag" clearable></el-autocomplete>
            </el-form-item>


        </el-form>
    </div>
</template>

<script>
import { GetAtlasCategoryList, GetAtlasTagList } from '@/request/api'

export default {
    name: "WallpaperListProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            myTemplateOptioins: [
                { name: "模板1", value: 1 },
                { name: "模板2", value: 2 },
                { name: "模板3", value: 3 },
                { name: "模板4", value: 4 },
            ],
            queryCategory: '',
            queryTag: '',
        }
    },
    mounted() {
        if (this.myObj.source_list.ignore) {
            this.queryCategory = this.myObj.source_list.ignore.category_name
            this.queryTag = this.myObj.source_list.ignore.tag_name
        }
    },
    methods: {
        /**
         * 查询大栏目
         */
        querySearchCategory(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasCategoryList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.categoryID
                        }
                    })
                    cb(list)
                })
        },
        /**
         * 查询标签
         */
        querySearchTag(queryString, cb) {
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetAtlasTagList(params)
                .then(data => {
                    const list = data.list.map(item => {
                        return {
                            value: item.name,
                            id: item.tagID
                        }
                    })
                    cb(list)
                })
        },
        handleSelectCategory(item) {
            this.queryCategory = item.value
            this.myObj.source_list.params.category_id = item.id
            //辅助回显信息
            if (!this.myObj.source_list.ignore) {
                this.myObj.source_list.ignore = {}
            }
            this.myObj.source_list.ignore.category_name = item.value
        },
        handleSelectTag(item) {
            this.queryTag = item.value
            this.myObj.source_list.params.tag_id = item.id
            //辅助回显信息
            if (!this.myObj.source_list.ignore) {
                this.myObj.source_list.ignore = {}
            }
            this.myObj.source_list.ignore.tag_name = item.value
        },
    }
}
</script>

<style scoped lang="less">

</style>